export default "__VITE_ASSET__CXagxOLx__"